<template>
  <div class="content importList import-box import_new_wrap">
    <div class="import-title">
      <div class="back" @click="$router.back()">返回</div>
      <span>题目标签-导入历史记录</span>
    </div>
    <div class="button-area mt0">
      <div>
        <el-button size="mini" type="importNew" @click="dialogVisible = true"
          >批量导入</el-button
        >
        <el-button size="mini" type="borderGreen" @click="refreshData">
          刷新结果
        </el-button>
        <span style="color: #999; margin-left: 10px">
          请及时刷新查看最终结果
        </span>
      </div>
      <div class="mr16">
        <el-button size="mini" type="deleteNew" @click="delFile(1)">
          批量删除
        </el-button>
      </div>
    </div>
    <div class="back-color-fff content-main-box">
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="light"
        v-loading="tableLoading"
        stripe
        :height="tableHeight"
      >
        <el-table-column
          type="selection"
          width="40"
          header-align="center"
          align="center"
          :selectable="selected"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="fileName"
          label="文件名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="350"
        >
          <template slot-scope="scope">{{
            scope.row.fileName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="importState"
          label="状态"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="85"
        >
          <template slot-scope="scope">
            <span :class="getStateClass(scope.row.importState)">
              {{ scope.row.importState | importStateNew }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="importMessage"
          label="导入结果"
          header-align="center"
          align="left"
          show-overflow-tooltip
          min-width="250"
        >
          <template slot-scope="scope">
            {{ scope.row.importMessage || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | getTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bank"
          width="230px"
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <a
              :class="
                scope.row.importState == 1
                  ? 'fontC-bbb cursor-sty'
                  : 'txt-color'
              "
              @click="
                downloadFile(scope.row.filePath, 1, scope.row.importState)
              "
            >
              下载文件
            </a>
            <a
              class="txt-color"
              @click="downloadFile(scope.row.errorFilePath, 2)"
              v-if="scope.row.importState == -1"
            >
              ｜下载异常数据
            </a>
            <a
              class="txt-color"
              @click="delFile(2, scope.row.guid)"
              v-if="scope.row.importState !== 1"
            >
              ｜删除
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="导入数据" :visible.sync="dialogVisible" width="800px">
      <div class="import-dialog-box">
        <div class="import-dialog-title">
          <img src="../../assets/icon/import_warning.png" alt="" />
          若导入数据已存在，那么信息将会覆盖，请谨慎操作。
        </div>
        <div class="import-dialog-item">
          <div class="import-step-title">
            1、请下载最新的模板，并按照模板格式准备需要导入的数据
          </div>
          <div class="t-left">
            <el-button
              size="mini"
              icon="el-icon-my-down"
              style="margin-top: 8px; margin-bottom: 0"
              type="importDown"
              @click="downloadFile(templateUrl)"
              >下载模板</el-button
            >
          </div>
        </div>
        <div class="import-dialog-item">
          <div class="import-step-title">2、选择准备好的文件导入</div>
          <div class="import-step-tip">
            当前支持xls、xlsx文件，单个文件不得大于5M
          </div>
          <el-upload
            class="upload-demo t-left"
            action="#"
            :file-list="fileList"
            :before-upload="beforeUpload"
            multiple
            accept=".xlsx,.xsl,.xls,.xlsm"
            :auto-upload="false"
            :on-change="changeFile"
          >
            <el-button
              size="mini"
              icon="el-icon-my-import"
              style="margin-top: 8px; margin-bottom: 0"
              type="importNew"
              v-loading.fullscreen.lock="fullscreenLoading"
              >导入文件</el-button
            >
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="importSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import importCommon from "@/uilt/importCommon";

export default {
  data() {
    return {
      exportUrl: `/${serverConfig.msCommonImportDataService}/import-data/import-common`,
      tableLoading: false,
      tableHeight: window.innerHeight - 278,
      tableData: [],
      multipleSelection: [],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        importType: "0047",
      },
      dialogVisible: false,
      templateUrl: "/题目标签导入模板.xlsx",
      fileList: [],
      fullscreenLoading: false,
    };
  },
  methods: {
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split(".");
      if (arr[1] !== "xls" && arr[1] !== "xlsx" && arr[1] !== "xlsm") {
        this.$message.error("上传文件只能是 excel/xls 格式!");
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    changeFile(file, fileList) {
      let self = this;
      if (fileList.length > 1 && file.status !== "fail") {
        fileList.splice(0, 1);
      }
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        self.$message.error("上传文件大小不能超过 5MB");
        file = null;
        fileList = [];
      } else {
        self.fullscreenLoading = true;
        let userInfo = JSON.parse(localStorage.userInfo);
        let extendFields = JSON.stringify({
          serviceTenantGuid: localStorage.guid,
        });
        let formData = new FormData();
        formData.append("file", file.raw);
        formData.append("importType", self.page.importType);
        formData.append("extendFields", extendFields);
        formData.append("tenantGuid", localStorage.guid);
        formData.append("staffGuid", userInfo.staffGuid);
        self.api.postFile(self.exportUrl, formData).then(function (res) {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: "success",
              message: messageConfig.UPLOAD_SUCCESS,
            });
            self.getData(1);
          } else {
            self.$message({
              type: "error",
              message: res.data.msg,
            });
            return false;
          }
        });
      }
    },
    refreshData() {
      this.page.pageIndex = 1;
      this.getData();
    },
    async getData() {
      const self = this;
      const query = JSON.parse(JSON.stringify(self.page));
      const userInfo = JSON.parse(localStorage.userInfo);
      query.staffGuid = userInfo.staffGuid;
      self.tableLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msCommonImportDataService}/import-data/list`,
        query
      );
      self.tableLoading = false;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.tableData = data.data.records || [];
      self.page.totalPage = data.data.totalPages;
      self.page.totalRows = data.data.totalRows;
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach((i) => {
          this.multipleSelection.push(i.guid);
        });
      }
    },
    selected(row) {
      return importCommon.getDelSelected(row.importState);
    },
    getStateClass(state) {
      return importCommon.getImportStateClass(state);
    },
    downloadFile(url, type, state) {
      if (type == 1 && state == 1) {
        this.$message.error(messageConfig.IMPORT_HANDLE);
        return;
      }
      if (!url) {
        this.$message.error(messageConfig.IMPORT_FILE_BROKEN);
        return;
      }
      window.open(url);
    },
    async delFile(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (!self.multipleSelection.length) {
          self.$message.error(messageConfig.DELETE_SELECT);
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }

      let res = null;
      try {
        res = await this.$confirm(messageConfig.DELETE_AFTER, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        res = "cancel";
        if (error === "cancel") {
          this.$message({
            type: "info",
            message: messageConfig.CANCEL_TIP,
          });
        }
      }
      if (res !== "confirm") {
        return;
      }
      self.tableLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msCommonImportDataService}/import-data/delete`,
        self.multipleSelection
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.tableLoading = false;
        self.$message.error(data.msg);
        return;
      }
      self.tableLoading = false;
      self.multipleSelection = [];
      self.$message.success(messageConfig.DELETE_SUCCESS);
      self.page.pageIndex = 1;
      self.getData();
    },
    importSure() {
      this.getData(true);
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 54px - 58px);
  overflow-y: auto;
}

.import-title {
  background: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

  .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
}
/deep/ .import-dialog-title {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  color: #212121;
  background: #fffbf2;
  border-radius: 4px;
  border: 1px solid #fff1d4;
  font-size: 14px;
}
/deep/ .import-dialog-title img {
  width: 16px;
  height: 16px;
  margin: 0 10px 0 20px;
}
/deep/ .import-dialog-item {
  margin-top: 16px;
}
/deep/ .import-step-title {
  color: #212121;
  text-align: left;
  font-size: 14px;
  font-weight: normal;
}
/deep/ .dialog-input-box {
  display: flex;
  align-items: center;
  margin: 10px 0;
}
/deep/ .dialog-input-title {
  margin: 0 16px;
  color: #666666;
}
/deep/ .import-step-tip {
  color: #666666;
  text-align: left;
  margin: 8px 0;
}
</style>
